import { useEffect, useState } from 'react'

const config = { childList: true }

const Empty = ({
	children,
	elementRef,
	contentClassName,
	startEmpty = false,
}) => {
	const [isEmpty, setIsEmpty] = useState(startEmpty)

	useEffect(() => {
		if (!elementRef.current) return
		const element = elementRef.current.querySelector(
			`.${contentClassName} > *:first-child`
		)
		if (!element) {
			setIsEmpty(true)
			return
		}

		const handleMutations = () => {
			setIsEmpty(element.children.length === 0)
		}
		const observer = new MutationObserver(handleMutations)
		observer.observe(element, config)
		handleMutations()
		return () => {
			observer.disconnect()
		}
	}, [contentClassName, elementRef])

	return children(isEmpty)
}

export default Empty
